import { Navigate, Outlet } from "react-router-dom";
import { ROUTES } from "@/config/constants";
import { canAccessOperadorApp } from "@/lib/appAccess";
import { useAuth } from "@/hooks/useAuth";

/** Protege rotas /operador — exige vínculo como operador de contrato ativo. */
export function OperadorRoute() {
  const { user } = useAuth();

  if (!canAccessOperadorApp(user?.locacoesOperador)) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return <Outlet />;
}
